import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Store } from '@ngxs/store';
import { SetPipes } from 'app/state-management/actions/organizations.actions';
import { OrganizationsState } from 'app/state-management/states/organizations.states';
import { take } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CurrentOrganizationPipesResolverService implements Resolve<string[]> {

  constructor(
    public ngxsStore: Store,
  ) {
  }

  resolve(route: ActivatedRouteSnapshot) {
    return this.ngxsStore.select(OrganizationsState.getSelectedOrganizationTreeIds)
      .pipe(
        take(1),
        switchMap(ids => (this.ngxsStore.dispatch(new SetPipes(ids)))
        )
      );
  }
}
